import React from 'react'
import ProductContainer from '../../../../Components/Applications/ECommerce/Product'

export default function Product() {
  return (
    <div className='page-body'>
        <ProductContainer/>
    </div>
  )
}
